import { useState } from 'react';
import { Link, useLocation } from 'react-router';

import { Icon } from '@/components/ui/Icon';
import { useAuth } from '@/features/auth/useAuth';
import { findActiveNavTarget, getVisibleNavSections } from '@/layouts/navigation';
import { ROUTES } from '@/routes/paths';
import { ThemeSwitcher } from '@/theme/ThemeSwitcher';
import { env } from '@/utils/env';

import { AppNav } from './AppNav';
import styles from './AppLayout.module.css';
import { MobileNav } from './MobileNav';
import { UserMenu } from './UserMenu';

const MOBILE_NAV_ID = 'mobile-nav';

/** Sticky top navbar: brand, permission-aware section links, theme and account menus. */
export function AppHeader() {
  const { hasPermission } = useAuth();
  const { pathname } = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const sections = getVisibleNavSections(hasPermission);
  const activeTarget = findActiveNavTarget(sections, pathname);

  return (
    <header className={styles.header}>
      <div className={styles.headerInner}>
        <Link to={ROUTES.root} className={styles.brand}>
          <span className={styles.brandMark} aria-hidden="true">
            <Icon name="file-earmark-text" />
          </span>
          <span className={styles.brandName}>{env.appName}</span>
        </Link>

        <AppNav sections={sections} activeTarget={activeTarget} />

        <div className={styles.headerActions}>
          <ThemeSwitcher />
          <UserMenu />
          <button
            type="button"
            className={`btn btn-link d-lg-none ${styles.iconButton}`}
            onClick={() => setIsMenuOpen(true)}
            aria-controls={MOBILE_NAV_ID}
            aria-expanded={isMenuOpen}
            aria-label="Open navigation menu"
          >
            <Icon name="list" />
          </button>
        </div>
      </div>

      <MobileNav
        id={MOBILE_NAV_ID}
        show={isMenuOpen}
        onHide={() => setIsMenuOpen(false)}
        sections={sections}
        activeTarget={activeTarget}
      />
    </header>
  );
}
